var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M6.502 24.713A15.146 15.146 0 0 1 5 18.113C5 9.766 11.716 3 20 3c8.284 0 15 6.766 15 15.113 0 6.97-4.683 12.838-11.053 14.584l.754 2.846a1.159 1.159 0 0 1-.809 1.418c-.123.033-.25.045-.377.036-7.386-.53-14.048-5.204-17.013-12.284zm6.796-4.873a2.08 2.08 0 0 0 2.074-2.085 2.08 2.08 0 0 0-2.074-2.085 2.08 2.08 0 0 0-2.075 2.085 2.08 2.08 0 0 0 2.075 2.085zm6.702 0a2.08 2.08 0 0 0 2.074-2.085A2.08 2.08 0 0 0 20 15.67a2.08 2.08 0 0 0-2.074 2.085A2.08 2.08 0 0 0 20 19.84zm6.702 0a2.08 2.08 0 0 0 2.075-2.085 2.08 2.08 0 0 0-2.075-2.085 2.08 2.08 0 0 0-2.074 2.085 2.08 2.08 0 0 0 2.074 2.085z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "130%",
    height: "126.5%",
    x: "-15%",
    y: "-13.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/Chat.e9cd1760.svg";
export { ForwardRef as ReactComponent };